<template>
  <div class="youKuIndex">
    <div class="youKuHeader">
      <!-- <div class="headerBar"> -->
        <!-- <div class="barVioce"></div>
        <div class="barWord">
        </div>

        <div class="barPlay" @click="goToRecord()"></div> -->

        <van-notice-bar left-icon="volume-o" :scrollable="false" class="headerBar">
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="10000"
            :show-indicators="false"
            style="height: 24px;width: 250px;font-size:12px"
          >
            <van-swipe-item v-for="(item, index) in barWord" :key="index"> {{item}}</van-swipe-item>
          </van-swipe>
          
        </van-notice-bar>
        <div class="barPlay" @click="goToRecord()"></div>
      <!-- </div> -->

      <div class="headerImg" >
        <div class="imgYouKu"></div>
        <div class="imgHelp" @click="goToForward()" v-show="client !== 'app'"></div>
        <div class="imgContent"> 
          
          <div class="imgWord">
            每月仅需8元
          </div>
        </div>
        

      </div>
    </div>
    <div class="youKuContent">
      <div class="contentIcon">
        <div class="iconItem" v-for="(item, index) in Icon" :key="index" @click="goToWhere(item.imgText)">
          <img :src="item.imgUrl">
          <span>{{item.imgText}}</span>
        </div>
      </div>
      <div class="contentBg">
        <div class="bgItem" v-for="(item, index) in Bg" :key="index">
          <img :src="item.imgUrl">
          <div class="bg2"></div>
        </div>
        <div class="bgIcon"></div>
      </div>
      <div class="contentRadio">
        <van-radio-group v-model="use_qualifications" direction="horizontal">
          <van-radio name="0">118元</van-radio>
          <van-radio name="1" @click="goToForward2()" v-show="client !== 'app'">立减20元</van-radio>
        </van-radio-group>
      </div>
      <div class="contentInput">
        <input class="inputPhone" type="text" placeholder="请输入手机号码" v-model="phone">
        <input class="inputBtn" type="button" value="点击抢购" @click="pay()">
      </div>
      <div class="contentDescribe">
        <div class="describeTitle">包年使用说明</div>
        <div class="describe">
          <!-- <p v-for="item in describe" :key="item" >{{item}} </p> -->
          <p>1、自动到账:抢购超低优酷会员年包成功后,权益将在5分钟内自动充值到您的手机号码上</p>
          <p>2、<span class="red">按月领取</span>:根据您的需求,按月自动领取会员</p>
          <p>3、登录使用:领取成功后,使用手机号码登录优酷视AP/官网,即可享受会员权益了</p>
          <p>4、权益说明:热剧抢先看,独家特供,免广告,1080p,极速存等</p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Param from '../../assets/js/Param.js'
import { checkBrowser } from '../../assets/js/common.js'
import { Dialog, Toast, Notify, NoticeBar, Swipe, SwipeItem, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      barWord: [],
      Icon: [
        // {imgUrl:require('../../assets/img/youkuCard/icon1.png'), imgText: '抢购年包'},
        {imgUrl:require('../../assets/img/youkuCard/icon2.png'), imgText: '年包兑换'},
        {imgUrl:require('../../assets/img/youkuCard/icon3.png'), imgText: '兑换码兑换'}
      ],
      Bg: [
        {imgUrl:require('../../assets/img/youkuCard/bg1.png')}
      ],
      describe: [
        '1、自动到账:抢购超低优酷会员年包成功后,权益将在5分钟内自动充值到您的手机号码上',
        '2、按月领取:根据您的需求,按月自动领取会员',
        '3、登录使用:领取成功后,使用手机号码登录优酷视AP/官网,即可享受会员权益了',
        '4、权益说明:热剧抢先看,独家特供,免广告,1080p,极速存等'
      ],
      phone: null,
      use_qualifications: '0',
      payDiscountFlag: false,
      activity_id: null,
      client: checkBrowser()
    }
  },
  components: {
    vanNoticeBar : NoticeBar,
    vanSwipe : Swipe,
    vanSwipeItem : SwipeItem,
    vanRadio: Radio,
    vanRadioGroup: RadioGroup
  },
  created() {
    this.payDiscount()
  },
  mounted() {
    this.userList()
    setInterval(() => {
      this.userList()
    }, 10000 * 10)
  },
  methods: {
    goToWhere(index) {
      switch(index) {
        case '年包兑换':
          this.$router.push('/youKu/yearBag')
          break;
        case '兑换码兑换':
          this.$router.push('/exchange')
          break;
      }
    },
    goToForward() {
      this.$router.push({
        name: 'youKuForward',
        params: {
          activity_id: this.activity_id
        }
      })
    },
    goToForward2() {
      if (this.payDiscountFlag) {
        Dialog.alert({
          title: '温馨提示',
          message: '您暂未活动优惠',
          confirmButtonText: '立即前往',
          showCancelButton: true
        }).then(() => {
          this.$router.push({
            name: 'youKuForward',
            params: {
              activity_id: this.activity_id
            }
          })
        })
      }
    },
    goToRecord() {
      this.$router.push('/youKu/recordList')
    },
    pay() {
      if (!this.phone) {
        Notify({message: '请输入您的手机号'});
        return false;
      } 
      if (!(/^(13[0-9]|14[5679]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/).test(this.phone)) {
        Notify({message: '请输入正确的手机号'});
        return false;
      }

      if (this.$route.query.use_qualifications) {
        this.use_qualifications = 1
      }
 
      Dialog.alert({
        title: '温馨提示',
        message: '将自动为该号码注册优酷会员，请您确认是否可接收到短信验证码！'
      }).then((res) => {

        this.$http.post('/test/v1/yk-vip-annual-package/pay-submit?' + Param.init().re(), {
          account: this.phone,
          use_qualifications: this.use_qualifications,
          pay_type: checkBrowser() == 'app' ? 'WEIXINH5' : 'WEIXIN'
        }, {
          emulateJSON: true
        }).then(res => {
          if (res.data.error == 0) {
            if (checkBrowser() == 'app') window.location.href = res.data.data.url
            else {
              const div = document.createElement('div');
              div.innerHTML = res.data.data.url;
              document.body.appendChild(div);
              document.forms[0].submit();
            }
          }else {
            Notify({
              message: res.data.msg
            })
          }
        })
      })

    },
    userList() {
      this.$http.get('/test/v1/yk-vip-annual-package/carousel-user-list?' + Param.init().re()).then((res) => {
        if (res.data.error == 0) {
          for(var item in res.data.data) {
            this.barWord.push(res.data.data[item])
          }
        }
      })
    },
    payDiscount() {
      this.$http.get('/test/v1/rc-activity/status-by-user?' + Param.init().re()).then((res) => {
        if (res.data.error == 0) {
          this.activity_id = res.data.data.activity_id 
          if (res.data.data.activity_status == 1) {
            this.use_qualifications = '1' 
            this.payDiscountFlag = false
          } else {
            this.use_qualifications = '0' 
            this.payDiscountFlag = true
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="less">

@keyframes heartBeat {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    14% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3)
    }

    28% {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    42% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3)
    }

    70% {
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}
  .notice-swipe {
    width: 3rem;
    line-height: .4rem;

  }
  .van-swipe-item{
    line-height: 24px;
  }
  .youKuIndex {
    width: 100%;
    height: 100%;
    .youKuHeader {
      display: inline-block;
      width: 100%;
      height: 3.7rem;
      background: #01CA9E;
      display: flex;
      align-items: center;
      flex-direction: column;
      .headerBar {
        width: 82%;
        height: .48rem;
        background: #54D2B6;
        border-radius: 10px;
        margin: .25rem 0;
        display: flex;
        align-items: center;
        color: #007857;
        .notice-swipe {
          width: 3rem;
        }
        .barVioce {
          width: .28rem;
          height: .28rem;
          background: url("../../assets/img/youkuCard/barVioce.png");
          background-size: 100%;
          margin: 0 .3rem;
        }
        .barWord {
          flex: 1;
          font-size: .22rem;
          text-align: center;
          font-weight: 600;
          color: #007857;
        }

      }
      .barPlay {
        position:absolute;
        top: .35rem;
        right: .2rem;
        width: .22rem;
        height: .22rem;
        background: url("../../assets/img/youkuCard/barPlay.png");
        background-size: 100%;
        margin: 0 .3rem;
      }
      .headerImg {
        position: relative;
        width: 88%;
        height: 2.7rem;
        background: #fff;
        border-radius: 12px 12px 0 0;
        background: url("../../assets/img/youkuCard/barImg2.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        font-size: .2rem;
        .imgYouKu {
          position: absolute;
          top: 0;
          left: 0;
          width: 1.1rem;
          height: .67rem;
          background: url("../../assets/img/youkuCard/imgYouKu.png");
          background-size: 100% 100%;
          margin: .1rem 0 0 .1rem;
          
        }
        .imgHelp {
          position: absolute;
          width: 1.4rem;
          height: 2.48rem;
          background: url("../../assets/img/youkuCard/imgHelp.png");
          background-size: 100% 100%;
          top: -.65rem;
          right: 0;
          -webkit-animation-name: heartBeat;
          animation-name: heartBeat;
          -webkit-animation-duration: 1.3s;
          animation-duration: 1.3s;
          -webkit-animation-timing-function: ease-in-out;
          animation-timing-function: ease-in-out;
          animation-delay: 1s;
          -webkit-animation-delay: 1s;
          animation-iteration-count: infinite;
          -webkit-animation-iteration-count: infinite;
        }
        .imgContent {
          display: flex;
          align-items: center;
          position: absolute;
          bottom: -.2rem;
          font-size: .22rem;
          .imgWord {
            position: relative;
            top: -.3rem;
            width: 3rem;
            height: .65rem;
            background: url("../../assets/img/youkuCard/barImg3.png");
            background-size: 100% 100%;
            font-size: .32rem;
            letter-spacing: 0.01rem;
            font-weight: 600;
            text-align: center;
            line-height: .65rem;
            color: #FFFFFF;
          }
        }

      }
    }
    .youKuContent {
      display: inline-block;
      width: 100%;
      background: #ECECEC;
      .contentIcon {
        width: 88%;
        margin: 0 auto;
        height: 1.6rem;
        display: flex;
        .iconItem {
          display: flex;
          flex-direction: column;
          padding: .1rem .5rem 0rem 0;
          color: #515151;
          justify-content: center;
          align-items: center;
          img {
            width: 1rem;
            height: 1rem;
          }
          span {
            font-size: .22rem;
            letter-spacing: 1px;
          }
        }
      }
      .contentBg {
        width: 100%;
        position: relative;
        .bgItem {
          width: 88%;
          margin: 0 auto;
          img {
            width: 100%;
            border-radius: 5px;
          }
          .bg2 {
            position: absolute;
            bottom: .6rem;
            width: 3.168rem;
            height: .768rem;
            background: url("../../assets/img/youkuCard/bg2.png");
            background-size: 100% 100%;
          }
        }
        .bgIcon {
          margin: .1rem auto 0 auto;
          width: .4rem;
          height: .3rem;
          background: url("../../assets/img/youkuCard/bgIcon.png");
          background-size: 100% 100%;
        }
      }
      .contentRadio {
        
        font-size: .26rem;
        .van-radio-group {
          display: flex;
          justify-content: center;
          .van-radio {
            margin: 0 .8rem;
          }
        }
      }
      .contentInput {
        width: 88%;
        margin: .05rem auto 0 auto;
        .inputPhone {
          width: 100%;
          height: .8rem;
          border-radius: 20px;
          border: 1px solid #54D2B6;
          margin: .1rem 0;
          text-align: center;
          color: #54D2B6;
          font-size: .28rem;
        }
        .inputBtn {
          width: 100%;
          height: .8rem;
          border-radius: 20px;
          background: #54D2B6;
          border: 0;
          margin: .1rem 0;
          color: #FFFFFF;
          font-size: .30rem;
          font-weight: 600;
          letter-spacing: 1px;
        }
      }
      .contentDescribe {
        width: 88%;
        margin: .1rem auto 0 auto;
        .describeTitle {
          width: 45%;
          margin: 0 auto;
          background: #FFAA00;
          border-radius: 20px;
          height: .55rem;
          color: #FFFFFF;
          font-size: .3rem;
          text-align: center;
          line-height: .55rem;
        }
        .describe {
          width: 100%;
          font-size: .27rem;
          padding: 0 .3rem 0 .3rem;
          box-sizing: border-box;
          color: #949494;
          p {
            margin-top: 0.15rem;
          }
          .red {
            color: #f44336;
          }
        }
      }
    }
  }
  input[type=button]{-webkit-appearance: none;}
  .inputPhone::-webkit-input-placeholder{
    color: #54D2B6;
  }    /* 使用webkit内核的浏览器 */
  .inputPhone::-moz-placeholder{
    color: #54D2B6;
  }                  /* Firefox版本4-18 */
  .inputPhone::-moz-placeholder{
    color: #54D2B6;
  }                  /* Firefox版本19+ */
  .inputPhone::-ms-input-placeholder{
    color: #54D2B6;
  }


</style>


// WEBPACK FOOTER //
// src/components/youKu/index.vue